import {observable, action, computed} from 'mobx';
import AssetInstitutionService from '../../services/AssetInstitutionService';
import {objDeepCopy, isEmpty} from '../../utils/tool';

class AssetMechanismSelectionInstitution {
  condition = {};
  @observable promotionAuctionList = []; // 机构选聘信息
  @observable promotionPageNo = 1; // 机构选聘分页
  @observable promotionListHasMore = true; // 机构选聘列表加载
  @observable realTimeData = {};
  @observable vendorId = ''; // 商家Id
  @observable publishTimeSort = 1; // 默认排序
  @observable keyWord = '' // 商品搜索关键词
  // 缓存数据初始化
  // 缓存数据来自 滚动事件 滚动高度 筛选条件 数据列表
  @action.bound
  promotionInitStore(allStatus) {
    for (let key in allStatus) {
      this[key] = allStatus[key];
    }
  }

  @action.bound
  saveCurrData(name, data) {
    this[name] = objDeepCopy(data);
  }
  @action.bound
  changeKeyWord(val){
    this.keyWord = val
  }
  @action.bound
  addCondition(condition) {
    for (let key in condition) {
      if (condition[key] == 'none') {
        delete this.condition[key];
        delete condition[key];
      }
    }

    this.resetAuctionList();
    this.condition = Object.assign(this.condition, condition);
    this.getMechanismSelectionList();
  }

  @action.bound
  resetCondition() {
    this.condition = {};
  }

  @action.bound
  resetAuctionList() {
    this.promotionAuctionList = []; // 清空机构选聘列表信息
    this.promotionPageNo = 1; // 分页
    this.promotionListHasMore = true; // 列表加载
    this.realTimeData = {};
  }

  @action.bound
  getSelectionParams() {
    let promotionParams = {venderId: this.vendorId, pageNo: this.promotionPageNo, pageSize: 10,publishTimeSort:this.publishTimeSort};
    if (isEmpty(this.condition)) {
      promotionParams = Object.assign(promotionParams);
    } else {
      promotionParams = Object.assign(promotionParams, this.condition);
    }
    promotionParams.keyWord = this.keyWord.trim();
    return promotionParams
  }

  @action.bound
  getMechanismSelectionList() {
    const promotionParams = this.getSelectionParams()
    // 机构选聘列表
    return AssetInstitutionService.getMechanismSelectionList(promotionParams).then(
      res => {
        let promotionAuctionList = [];
        if (res && res.data && res.data.data && res.data.data.length>0) {
          promotionAuctionList = res.data.data;
          this.promotionAuctionList.push(...promotionAuctionList);
          if (promotionAuctionList.length < 10) {
            this.promotionListHasMore = false;
          }
          this.promotionPageNo += 1;
        } else {
          this.promotionListHasMore = false;
        }
        return Promise.resolve();
      }
    )

  }

  setAssetPromotionData = () => {
    sessionStorage.setItem('assetPromotionIndex', JSON.stringify({
      promotionPageNo: this.promotionPageNo,
      promotionListHasMore: this.promotionListHasMore,
      promotionAuctionList: this.promotionAuctionList,
      condition: this.condition,
      realTimeData: this.realTimeData,
      SortItem: this.SortItem,
      LocationItem: this.LocationItem,
      MoreItem: this.MoreItem,
      currFilterItems: this.currFilterItems,
    }))
  }
}

let assetPromotionInstitution = new AssetMechanismSelectionInstitution();

export default assetPromotionInstitution;
